import { useState } from "react";
import i18next from "i18next";
import { locales } from "utils/constants/index";
import SelectDefault from "components/InputFields/SelectDefault";

function LanguagePicker() {
  const [language, setLanguage] = useState(i18next.language || window.localStorage.i18nextLng);
  return (
    <SelectDefault
      opensUp
      value={
        locales.find((locale) => locale.value === language) ||
        locales.find((locale) => locale.value === language?.split("-")[0]) ||
        locales[0]
      }
      options={locales}
      onChange={(option) => {
        i18next.changeLanguage(option.value);
        setLanguage(option.value);
      }}
    />
  );
}

export default LanguagePicker;
